module.exports = __webpack_public_path__ + "img/1x.03838d1.jpg";